import { Injectable } from "@angular/core";
import { Observable } from 'rxjs';

import { BaseService } from 'app/_services/base.service';
import { SettingsService } from "app/_services/settings.service";
import { UserService } from 'app/_services/user.service';

@Injectable({ providedIn: 'root' })
export class CookiesManagementService extends BaseService {
    private _domain: string = '/cookies/user';

    constructor(private userService: UserService, private config: SettingsService) {
        super();
    }

    public getUserCookieConsent(): Observable<any> {
        let userId = this.userService.user().id;

        return this.config.executeGet({ url: `${this._domain}/${userId}` });
    }

    public saveUserCookieConsent(acceptedCookies: number): Observable<any> {
        const userId = this.userService.user().id;
        const body = { acceptedCookies };

        return this.config.executePost({ url: `${this._domain}/${userId}`, body });
    }

    public saveUserCookieConsentAcceptAll(): Observable<any> {
        const userId = this.userService.user().id;

        return this.config.executePost({ url: `${this._domain}/${userId}/all` });
    }
}
